import ls from '@/util/ls';

const LocalStorage = {
	install(Vue) {
		Vue.prototype.$ls = ls;
	},
};

export default LocalStorage;
